<template>
  <article class="article-model">
    <section id="model-chart">
      <p class="model-desc">{{riskDetail}}</p>
      <pie-chart class="pie-chart" :id="'port-allocation-chart'" :data="piechartData" />
    </section>
    <section id="model-asset">
      <h3>กองทุนแนะนำ</h3>
      <div class="asset-box" v-for="(asset, index) in assets" :key="`asset-${index}`">
        <div class="color-symbol">
          <div class="point" :style="{ backgroundColor: mapPieChartColor(asset.category)}"></div>
        </div>
        <div class="code">{{asset.asset_code}}</div>
        <div class="percent">{{asset.percent}}%</div>
        <div class="amount">
          {{formatPrice(getAssetAmount(asset.percent))}}
          <span>฿</span>
        </div>
      </div>
    </section>
    <section id="model-return">
      <h3>ผลตอบแทนในอดีตของโมเดลพอร์ตนี้</h3>
      <bar-chart :id="'return-bar-chart'" :data="arrData"></bar-chart>
    </section>

    <section id="disclaimer">
      <p>
        *ผลการดำเนินงานในอดีต/ผลการเปรียบเทียบ ผลการดำเนินงานที่
        เกี่ยวข้องกับผลิตภัณฑ์ในตลาดทุน มิได้เป็นสิ่งยืนยันถึงผลการดำเนินงาน
        ในอนาคต
      </p>
      <p>
        *ผู้ลงทุนควรศึกษาข้อมูลสำคัญของกองทุน โดยเฉพาะนโยบายกองทุน
        ความเสี่ยง และผลการดำเนินงานของกองทุน โดยสามารถขอข้อมูลจาก
        ผู้แนะนำก่อนตัดสินใจลงทุน
      </p>
    </section>
    <section id="cta-model">
      <a class="cta-btn" v-on:click="openRecommend">บันทึกแผนการลงทุนนี้</a>
    </section>
  </article>
</template>
<script>
import axios from "axios";
import PieChart from "../charts/PieChart.vue";
import BarChart from "../charts/BarChart.vue";
import ColorPalettes from "../../config/color-palettes.json";
import qs from "qs-lite";
import { sendAnalytic } from "../../utils/analytic";

export default {
  components: {
    BarChart,
    PieChart
  },
  props: { userID: String, env: Object, finnakies: String },
  metaInfo: {
    title: "โมเดลพอร์ต"
  },
  data() {
    return {
      arrData: [],
      assets: [],
      piechartData: [],
      riskDetail: "",
      objQuery: {},
      palette: ColorPalettes.default,
      belowMinimum: null
    };
  },
  watch: {},
  methods: {
    openRecommend: function() {
      sendAnalytic({
        luid: this.userID,
        de: "line",
        ac: "click_open_recommend",
        ec: "create_flow",
        un: this.finnakies,
        in: this.objQuery.initial,
        ri: this.objQuery.risklevel,
        pl: this.$route.query.plan.toUpperCase(),
        mo: this.objQuery.contribution,
        ta: this.objQuery.goalmoney,
        cu: "sample_port_" + this.$route.query.plan,
        et: "on_click"
      });

      this.$router.push({
        name: "appintro",
        params: {
          userID: this.userID,
          finnakies: this.finnakies
        },
        query: this.objQuery
      });
    },
    getAssetAmount(percent) {
      return (parseInt(this.$route.query.initial) * percent) / 100;
    },
    mapPieChartColor(cat) {
      let index = this.piechartData.findIndex(asset => {
        return asset.name === cat;
      });

      return this.palette[index];
    },
    formatPrice(value) {
      let val = (value / 1).toFixed(0);
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
  },
  async mounted() {
    var objQueryStr = this.$route.query;

    sendAnalytic({
      luid: this.userID,
      de: "line",
      ac: "open",
      ec: "create_flow",
      un: this.finnakies,
      cu: "sample_port_" + this.$route.query.plan,
      et: "on_load"
    });

    try {
      let { data } = await axios({
        url: `/api/plan/public/model?${qs.stringify(objQueryStr)}`,
        method: "GET"
      });

      if (data.success) {
        data = data.data;
      }

      const categories = data.portData.categories;
      for (let i = 0; i < categories.length; i++) {
        this.piechartData.push({
          name: categories[i].category,
          percent: categories[i].percent
        });
      }

      const histPerf = data.riskData.hist_perf.data_point;
      for (let i = 0; i < histPerf.length; i++) {
        this.arrData.push({
          year: histPerf[i].label,
          value: histPerf[i].value
        });
      }

      this.riskDetail = data.riskData.detail;
      objQueryStr.below_minimum = data.riskData.below_minimum;

      this.objQuery = objQueryStr;

      this.assets = data.portData.assets;
    } catch (err) {
      let errorCode = "9999";
      if (err.response && err.response.data && err.response.data.message) {
        errorCode = err.response.data.message.code;
      }

      this.$router.push({
        name: err.response && err.response.status ? err.response.status : 503,
        params: {
          userID: this.userID,
          finnakies: this.finnakies,
          errorCode: errorCode
        },
        query: this.$route.query
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.article-model {
  padding: 16px;
  max-width: 450px;
  margin: 0 auto;
  #model-asset {
    .asset-box {
      margin: 8px;
      padding: 16px;
      border-radius: 4px;
      box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.11);
      background-color: $color-white;
      position: relative;

      .amount {
        width: 40%;
        text-align: right;
        display: inline-block;
        span {
          color: $color-secondary;
        }
      }

      .percent {
        width: 15%;
        display: inline-block;
        text-align: right;
        font-weight: bold;
      }

      .code {
        width: calc(40% - 8px);
        display: inline-block;
        text-align: left;
        margin-left: 8px;
        overflow-wrap: break-word;
      }

      .color-symbol {
        display: inline-block;
        width: 5%;
        font-weight: bold;

        .point {
          font-weight: normal;
          border-radius: 50%;
          width: 10px;
          height: 10px;
        }
      }
    }
  }
  #model-chart {
    .model-desc {
      padding: 0px 16px;
    }
  }
  #model-return {
    margin-top: 52px;
    padding-bottom: 24px;
    h3 {
      font-weight: bold;
      color: #454545;
    }
  }
  #disclaimer {
    padding-bottom: 62px;
    font-size: 12px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: normal;
    color: $color-secondary-text;
  }
  #cta-model {
    position: fixed;
    bottom: 0;
    width: 100%;
    left: 0;
    text-align: center;

    .cta-btn {
      text-decoration: none;
      @extend %btn-primary;
      font-style: normal;
      font-stretch: normal;
      padding: 12.5px 0;
      width: -webkit-fill-available;
    }
  }
}
</style>


